import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { PageTabRail } from '@interxfi/app-components/components/page-tab-rail/page-tab-rail';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { CorpactCaAdminPaymentsTable } from '../../../../../../../../../../features/corporate-action/ca-admin/payment/ca-admin-payments-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/ca/payment/_payment/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsCorporateActions,
      label: 'Payments',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsCorporateActions>,
  head: () => getPageHead('Corporate Action Payments'),
  component: CorporateActionPaymentsList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack align="end" blockAlign="center" gap={2}>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsCorporateActions}
    />
  );
}

function CorporateActionPaymentsList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <CorpactCaAdminPaymentsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
